module.exports = __webpack_public_path__ + "static/img/5.87b4d28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/5.png
// module id = DCGf
// module chunks = 0